module.exports = __webpack_public_path__ + "static/media/west-campus.04c0b0ab.jxr";